<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <h6>Cursos de Capacitación</h6>
                </v-card-title>
                <!-- <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="12" sm="12" md="6">
                            <v-text-field label="Filtro por Código" dense v-model="filtrocod">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6">
                            <v-text-field label="Filtro por Nombre de Documento" dense v-model="filtrodoc">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListado(filtrocod, filtrodoc)">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row> 
                </v-card-text>-->
            </v-card>
            <v-data-table dense :headers="headers" :items="listadodoc" locale="es-ar" class="elevation-1"
                :items-per-page="100" :footer-props="{
                    itemsPerPageText: 'Documentos por página',
                }">
                <template v-slot:item.tipo="{ item }">
                    <v-chip x-small :color="item.tipo === 'mp4' ? 'red' : 'blue'" dark>
                        <v-icon x-small left>{{ item.tipo === 'mp4' ? 'mdi-video' : 'mdi-file-pdf-box' }}</v-icon>
                        {{ item.tipo.toUpperCase() }}
                    </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small :color="item.tipo === 'mp4' ? 'red' : 'blue'" class="mr-2" v-on="on" v-bind="attrs"
                                @click.stop="verInforme(item)">
                                {{ item.tipo === 'mp4' ? 'mdi-play-circle' : 'mdi-eye' }}
                            </v-icon>
                        </template>
                        <span>{{ item.tipo === 'mp4' ? 'Ver Video' : 'Ver Documento' }}</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <Visualizardocumentos :visible="showInforme" :codigo="''" :nivel="''" :rutadoc="editedItem.descr"
                :tipoArchivo="editedItem.tipo"
                @close="showInforme = false"></Visualizardocumentos>
        </v-app>
    </div>
</template>

<script>
import Visualizardocumentos from "./Visualizardocumento.vue";
import axios from "../../../src/axios-auth";
export default {
    data: (vm) => ({
        filtrodoc: "",
        filtrocod: "",
        listadodoc: [{ descr: "SAS IEC 61850 - REDES COMUNICACIONES_1", area: "Ingeniería de Obra", fecha: "28/03/2024", tipo: "pdf" },
        { descr: "SAS IEC 61850 - INTRODUCCION_2", area: "Ingeniería de Obra", fecha: "04/04/2024", tipo: "pdf" },
        { descr: "SAS IEC 61850 - ARQUITECTURA_3", area: "Ingeniería de Obra", fecha: "11/04/2024", tipo: "pdf" },
        { descr: "Inteligencia Artifical (IA) Unidad 1", area: "RR HH", fecha: "25/06/2025", tipo: "pdf" },
        { descr: "Inteligencia Artifical (IA) Unidad 2", area: "RR HH", fecha: "25/06/2025", tipo: "pdf" },
        { descr: "Inteligencia Artifical (IA) Unidad 3", area: "RR HH", fecha: "25/06/2025", tipo: "pdf" },
        { descr: "Inteligencia Artifical (IA) Unidad 4", area: "RR HH", fecha: "25/06/2025", tipo: "pdf" },
        { descr: "Inteligencia Artifical (IA) Unidad 5", area: "RR HH", fecha: "25/06/2025", tipo: "pdf" },
        { descr: "Retos y Desafios IA", area: "RR HH", fecha: "25/06/2025", tipo: "pdf" },
        { descr: "Curso de IA - 1° Clase", area: "Todas las áreas", fecha: "17/04/2026", tipo: "mp4" },
        { descr: "Curso de IA - 2° Clase", area: "Todas las áreas", fecha: "24/04/2026", tipo: "mp4" },
        { descr: "Curso de IA - 3° Clase", area: "Todas las áreas", fecha: "08/05/2026", tipo: "mp4" },
        { descr: "Curso de IA - 4° Clase", area: "Todas las áreas", fecha: "15/05/2026", tipo: "mp4" },
        { descr: "Curso de IA - 5° Clase", area: "Todas las áreas", fecha: "22/05/2026", tipo: "mp4" },],
        editedItem: {},
        editedIndex: -1,
        headers: [
            { text: "Capacitación", value: "descr", width: "30%", sortable: false },
            { text: "Área", value: "area", width: "15%", sortable: false },
            { text: "Fecha", value: "fecha", sortable: false },
            { text: "Tipo", value: "tipo", align: "center", width: "80px", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],
        showInforme: false,
        rutadoc: "",
    }),
    components: { Visualizardocumentos },
    computed: {
        show: {
            get() {
                //this.cargarListado();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        verInforme(item) {
            this.editedIndex = this.listadodoc.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showInforme = true;
        },

        // cargarListado() {
        //     const filtrodoc = this.filtrodoc;
        //     const filtrocod = this.filtrocod;
        //     let self = this;
        //     axios
        //         .get("/Sgi/ListadoBuscarDoc?", {
        //             params: {
        //                 filtrodoc: filtrodoc,
        //                 filtrocod: filtrocod,
        //             },
        //         })
        //         .then((response) => {
        //             self.listadodoc = response.data;
        //         })
        //         .catch((error) => {
        //             self.listadodoc = [];
        //             console.log(error);
        //         });
        // },
    },
};
</script>